import * as React from 'react';
import { AsidePanelActionsButton } from '../../../..';
import {
    BOARD_BUTTON_OPEN_IN_DRIVE, BOARD_BUTTON_OPEN_IN_DRIVE_MS,
    BOARD_BUTTON_OPEN_IN_DRIVE_MS_PERSONAL
} from './constants';
import { IOpenInDriveButtonProps } from './types';
import { EAuthUserPlatformType } from '../../../../../../../types/rest/IRestAuthUser';

export function OpenInDriveButton ({
    isMSPersonalAccount,
    parentFolderInfo,
    platformType,
    onGetLink,
    onClick,
}: IOpenInDriveButtonProps) {
    const [link, setLink] = React.useState(null);
    const GoogleDriveIcon = require('!!@svgr/webpack!../../../../../../../../../../assets/svg/google-drive-colored-24.svg').default;
    const MicrosoftSharePointIcon = require('!!@svgr/webpack!../../../../../../../../../../assets/svg/microsoft-share-point.svg').default;
    const MicrosoftOneDriveIcon = require('!!@svgr/webpack!../../../../../../../../../../assets/svg/microsoft-one-drive.svg').default;

    React.useEffect(() => {
        onGetLink().then(result => {
            setLink(result);
        })
    }, [parentFolderInfo]);

    return (
        <AsidePanelActionsButton
            title={platformType === EAuthUserPlatformType.MICROSOFT
                ? isMSPersonalAccount
                    ? BOARD_BUTTON_OPEN_IN_DRIVE_MS_PERSONAL : BOARD_BUTTON_OPEN_IN_DRIVE_MS
                : BOARD_BUTTON_OPEN_IN_DRIVE}
            onClick={onClick}
            href={link}
            target={'_blank'}
            isDisabled={!link}
            rightIcon={platformType === EAuthUserPlatformType.GOOGLE ? (<GoogleDriveIcon/>) : isMSPersonalAccount ? <MicrosoftOneDriveIcon/> : <MicrosoftSharePointIcon/>}
        />
    );
};
